module.exports = __webpack_public_path__ + "img/Selesai.24671b83.svg";